import { BodyContent } from '@/api/types'
import { parse } from 'node-html-parser'

export const readTime = (body: BodyContent[]): string => {
  const text = body.map((b) => b.richContent).join()
  const content = parse(text)
  return `${Math.ceil(content.textContent.length / 1000)}min`
}
